<div class="form-container">
  <div class="form-title">Appraiser office</div>
  <div class="form-subtitle">{{ subtitle }}</div>

  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Office name</mat-label>
      <input matInput formControlName="name" placeholder="e.g. Highlands County Property Appraiser">
      <mat-error>Office name is required</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Office number</mat-label>
      <input matInput formControlName="officeNumber" placeholder="Office number">
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>County</mat-label>
      <input matInput formControlName="county" placeholder="County">
    </mat-form-field>

    <mat-checkbox formControlName="active">Active</mat-checkbox>

    <div class="form-actions">
      <button type="button" mat-stroked-button (click)="goBack()">GO BACK</button>
      <button type="submit" mat-flat-button color="primary">SAVE</button>
    </div>
  </form>
</div>
